import { render, staticRenderFns } from "./ContentSeoUrl.vue?vue&type=template&id=04226b17&"
import script from "./ContentSeoUrl.vue?vue&type=script&lang=js&"
export * from "./ContentSeoUrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../buildchain/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports